//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { TrackingId } from '@models/TrackingId';

export const TOP_NAV_BAR_HEIGHT = '56px';
export const TrackingIdSuffix = '-top-navigation-item';

export const NAV_MENU_ITEMS_TRACKING_ID = {
  CAMPAIGNS_NAV: `nt-campaigns${TrackingIdSuffix}`,
  COMMERCE_NAV: `commerce${TrackingIdSuffix}`,
  COMMUNITY_NAV: `creators${TrackingIdSuffix}`,
  CONTENT_NAV: `content${TrackingIdSuffix}`,
  CREATORS_NAV: `creators${TrackingIdSuffix}`,
  HOME_NAV: `home${TrackingIdSuffix}`,
  INBOX_NAV: `socialresponse${TrackingIdSuffix}`,
  INSIGHTS_NAV: `insights${TrackingIdSuffix}`,
  LISTENING_NAV: `social-listening${TrackingIdSuffix}`,
  PUBLISHING_NAV: `publishing${TrackingIdSuffix}`,
  SAMPLING_NAV: `campaigns${TrackingIdSuffix}`,
} as const satisfies Record<string, TrackingId>;

export const DropdownTrackingIdSuffix = '-nav-dropdown-item';

export const NAV_DROPDOWN_ITEMS_TRACKING_ID = {
  ANALYTICS_DROPDOWN: `analytics${DropdownTrackingIdSuffix}`,
  COMMUNITY_DROPDOWN: `community${DropdownTrackingIdSuffix}`,
  DISCOVER_DROPDOWN: `discover${DropdownTrackingIdSuffix}`,
  ECOMMERCE_DROPDOWN: `ecommerce${DropdownTrackingIdSuffix}`,
  EMAIL_DROPDOWN: `email${DropdownTrackingIdSuffix}`,
  GOOGLE_DROPDOWN: `google${DropdownTrackingIdSuffix}`,
  INSTASHOP_DROPDOWN: `instashop${DropdownTrackingIdSuffix}`,
  LIBRARY_DROPDOWN: `library${DropdownTrackingIdSuffix}`,
  PAID_SOCIAL_DROPDOWN: `paid-social${DropdownTrackingIdSuffix}`,
  REVEAL_DROPDOWN: `reveal${DropdownTrackingIdSuffix}`,
  SCHEDULE_DROPDOWN: `schedule${DropdownTrackingIdSuffix}`,
  SHARE_DROPDOWN: `share${DropdownTrackingIdSuffix}`,
  SOCIAL_DROPDOWN: `social${DropdownTrackingIdSuffix}`,
  VSN_DROPDOWN: `visual-syndication${DropdownTrackingIdSuffix}`,
} as const satisfies Record<string, TrackingId>;
